import type { ReactNode } from "react";

interface KpiCardProps {
  label: string;
  value: ReactNode;
  /** small suffix shown after the value (e.g. "件", "/50") */
  suffix?: ReactNode;
  delta?: string;
  deltaDir?: "up" | "down";
  className?: string;
}

export function KpiCard({ label, value, suffix, delta, deltaDir, className }: KpiCardProps) {
  return (
    <div className={["card", "crop", "kpi", className].filter(Boolean).join(" ")}>
      <div className="l">{label}</div>
      <div className="v">
        {value}
        {suffix ? <span style={{ fontSize: 15, color: "var(--muted)" }}> {suffix}</span> : null}
      </div>
      {delta ? <div className={`delta ${deltaDir ?? ""}`}>{delta}</div> : null}
    </div>
  );
}
